// extracted by mini-css-extract-plugin
module.exports = {"newsroom-banner-box":"e","newsroomBannerBox":"e","newsroomBannerLeft":"f","newsroomBannerRight":"g"};